import { connect, disconnect, isConnected } from 'helpers/wsocket';
import { useEffect, useState, useCallback } from 'react';

// Định nghĩa kiểu cho trạng thái kết nối
interface WebSocketState {
    isConnected: boolean;
    error: Error | null;
}

export const useConnectWebSocket = () => {

    const [state, setState] = useState<WebSocketState>({ isConnected: isConnected(), error: null });

    // Hàm kết nối
    const connectWS = useCallback(() => {
        try {
            console.log('===========connectWS===========');
            connect();
            setState({ isConnected: true, error: null });
        } catch (error) {
            setState({ isConnected: false, error: error as Error });
        }
    }, []);

    // Hàm ngắt kết nối
    const disconnectWS = useCallback(() => {
        disconnect();
        setState({ isConnected: false, error: null });
    }, []);

    // Theo dõi trạng thái kết nối
    useEffect(() => {
        connectWS();

        const checkConnection = () => {
            const connected = isConnected();
            setState((prev) => (prev.isConnected !== connected ? { ...prev, isConnected: connected } : prev));
        };

        const interval = setInterval(checkConnection, 1000);
        return () => {
            clearInterval(interval);
            // Không gọi disconnect để giữ kết nối singleton
        };
    }, [connectWS]);

    return {
        isConnected: state.isConnected,
        error: state.error,
        connect: connectWS,
        disconnect: disconnectWS,
    };
};